export default __webpack_public_path__ + "static/media/me-photo.085d2302.jpg";